import { Component, effect, input, signal } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { MenuModule } from 'primeng/menu';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { AmdCompanyDataComponent } from './components/amd-company-data/amd-company-data.component';
import { AmdAddressesComponent } from './components/amd-addresses/amd-addresses.component';
import { AmdContractsComponent } from './components/amd-contracts/amd-contracts.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

export type AccountMenuKey = 'company-data' | 'addresses' | 'contracts';
@Component({
  selector: 'app-account-management-dialog',
  imports: [
    CommonModule,
    DialogModule,
    TranslateModule,
    MenuModule,
    AmdCompanyDataComponent,
    AmdAddressesComponent,
    AmdContractsComponent,
  ],
  templateUrl: './account-management.dialog.component.html',
  styleUrl: './account-management.dialog.component.scss',
})
export class AccountManagementDialogComponent extends BaseDialogComponent {
  editMode = signal<boolean>(false);
  items = signal<MenuItem[]>([]);

  initialSelectedMenu = input<AccountMenuKey>('company-data');
  selectedMenu = signal<AccountMenuKey>('company-data');

  constructor(
    private translate: TranslateService,
    private router: Router,
  ) {
    super();

    this.initialMenuSelection();

    effect(() => {
      this.selectedMenu();
      this.clickSelectedMenu();
    });

    // Suscribirse a cambios de idioma
    this.translate.onLangChange.subscribe(() => {
      this.loadMenuItems();
    });
  }

  ngOnInit(): void {
    this.loadMenuItems();
  }

  onCloseDialog(): void {
    this.visible = false;
  }

  async loadMenuItems() {
    const [
      contractsLabel,
      billingLabel,
      contactsLabel,
      companyDataLabel,
      addressesLabel,
    ] = await Promise.all([
      firstValueFrom(
        this.translate.get('accountManagement.dialog.menu.contracts'),
      ),
      firstValueFrom(
        this.translate.get('accountManagement.dialog.menu.billingAndBankData'),
      ),
      firstValueFrom(
        this.translate.get('accountManagement.dialog.menu.contacts'),
      ),
      firstValueFrom(
        this.translate.get('accountManagement.dialog.menu.companyData'),
      ),
      firstValueFrom(
        this.translate.get('accountManagement.dialog.menu.addresses'),
      ),
    ]);

    this.items.set([
      {
        label: contractsLabel,
        id: 'contracts',
        command: () => this.selectedMenu.set('contracts'),
      },
      {
        label: billingLabel,
        id: 'billing',
        command: () => {
          this.router.navigate(['/account-management/billing']);
          this.close();
        },
      },
      {
        label: contactsLabel,
        id: 'contacts',
        command: () => {
          this.router.navigate(['/account-management/contacts']);
          this.close();
        },
      },
      {
        label: companyDataLabel,
        id: 'company-data',
        command: () => this.selectedMenu.set('company-data'),
      },
      {
        label: addressesLabel,
        id: 'addresses',
        command: () => this.selectedMenu.set('addresses'),
      },
    ]);
  }
  private initialMenuSelection() {
    this.visibleChange.subscribe((visible: boolean) => {
      if (visible) {
        setTimeout(() => {
          this.selectedMenu.set(this.initialSelectedMenu());
          this.clickSelectedMenu();
        });
      }
    });
  }

  private clickSelectedMenu() {
    const menuLis = document.querySelectorAll('li.p-menu-item');
    menuLis.forEach((li) => {
      if (li?.id === this.selectedMenu()) {
        li.classList.add('item-active');
        const link = li.querySelector('a');
        (link as HTMLElement).click();
      } else {
        li.classList.remove('item-active');
      }
    });
  }

  onModeChange(mode: 'edit' | 'detail') {
    this.editMode.set(mode === 'edit');
    this.toggleMenuDisabled();
    this.clickSelectedMenu();
  }

  toggleMenuDisabled() {
    this.items().forEach((it: MenuItem) => {
      it.disabled = this.editMode();
    });
  }
}
